module.exports = {
      id: "share-alt-usage",
      viewBox: "0 0 448 512",
      url: "/" + "sprite-8d2e5ebc566e02833b7f09cd596911c9.svg#share-alt",
      toString: function () {
        return this.url;
      }
    }